import { debounce } from "@mui/material";
import { ModalComponent } from "@zenith/components";
import { INACTIVITY_TIMER, LOGOUT_TIMER } from "@zenith/data/constants";
import { useEffect, useRef, useState } from "react";
import { HandleLogout } from "./handleLogout";

export const InactivityMethods = () => {
  const refInactivityTimer = useRef<NodeJS.Timeout | undefined>(undefined);
  const refSessionWarningTimeout = useRef<NodeJS.Timeout | undefined>(
    undefined
  );
  const [showWarningModal, setWarningModal] = useState<boolean>(false);
  const { handleLogout, loggingOut } = HandleLogout();
  const [trackingWindow, setTrackingWindow] = useState<boolean>(true);

  const debounceTime = debounce(() => {
    inactivityTimer();
  }, 1000);

  const handleLogoutUser = () => {
    setTrackingWindow(false);
    clearTimeout(refInactivityTimer.current);
    clearTimeout(refSessionWarningTimeout.current);
    handleLogout();
  };

  function inactivityTimer() {
    clearTimeout(refInactivityTimer.current);
    refInactivityTimer.current = setTimeout(() => {
      setWarningModal(true);
    }, INACTIVITY_TIMER);
  }

  function sessionWarningTimeout() {
    setTrackingWindow(false);
    clearTimeout(refInactivityTimer.current);
    refSessionWarningTimeout.current = setTimeout(() => {
      handleLogout();
    }, LOGOUT_TIMER);
  }

  function handleCloseModalActions(event?: object, reason?: string) {
    if (reason && reason.includes("backdropClick")) {
      return;
    }

    setWarningModal(false);
    setTrackingWindow(true);
    clearTimeout(refSessionWarningTimeout.current);
  }

  useEffect(() => {
    if (trackingWindow) {
      window.addEventListener("mousemove", debounceTime);
      window.addEventListener("keypress", debounceTime);
      window.addEventListener("scroll", debounceTime);
      window.addEventListener("click", debounceTime);
    }

    return () => {
      clearTimeout(refInactivityTimer.current);
      window.removeEventListener("mousemove", debounceTime);
      window.removeEventListener("keypress", debounceTime);
      window.removeEventListener("scroll", debounceTime);
      window.removeEventListener("click", debounceTime);
    };
  }, [trackingWindow]);

  useEffect(() => {
    if (showWarningModal) {
      sessionWarningTimeout();
    }
  }, [showWarningModal]);

  return {
    handleLogout,
    inactivityModal: (
      <ModalComponent
        body="Due to inactivity, your session will time out in 60 seconds"
        title="Session Time Out"
        showErrorIcon={false}
        showModal={showWarningModal}
        onClickClose={(event, reason) => handleCloseModalActions(event, reason)}
        doubleOptions={true}
        onLeftButtonClick={handleLogoutUser}
        onRightButtonClick={handleCloseModalActions}
        leftButtonText="Logout"
        isLeftLoading={loggingOut}
        rightButtonText="Continue"
      />
    ),
  };
};
